import { render, staticRenderFns } from "./ClassReEnrollment.vue?vue&type=template&id=42c34e96"
import script from "./ClassReEnrollment.vue?vue&type=script&lang=js"
export * from "./ClassReEnrollment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports